import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, unref as _unref, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[9999] flex items-center justify-center p-4"
}
const _hoisted_2 = { class: "relative w-full max-w-lg overflow-hidden rounded-3xl bg-white shadow-2xl transition-all" }
const _hoisted_3 = { class: "flex items-center justify-between border-b border-slate-100 px-6 py-4" }
const _hoisted_4 = { class: "grid grid-cols-12 md:gap-10" }
const _hoisted_5 = { class: "col-span-12 md:col-span-3 flex flex-col h-fit order-2 md:order-1 mt-12 md:mt-0" }
const _hoisted_6 = {
  key: 0,
  class: "fixed inset-0 z-[10000] flex flex-col items-center justify-center bg-slate-900/40 backdrop-blur-md"
}
const _hoisted_7 = { class: "col-span-12 md:col-span-9 flex flex-col order-1 md:order-2" }
const _hoisted_8 = { class: "flex flex-col border border-theme-gray-7 rounded-2xl overflow-hidden" }
const _hoisted_9 = { class: "bg-theme-gray-7 px-5 py-3.5 text-theme-gray-2 text-size-2 uppercase font-bold" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = { class: "grid grid-cols-2 md:divide-x divide-y md:divide-y-0 divide-theme-gray-7" }
const _hoisted_13 = { class: "col-span-2 md:col-span-1 flex flex-col gap-2 items-start px-4 py-5" }
const _hoisted_14 = {
  key: 0,
  class: "text-theme-error"
}
const _hoisted_15 = { class: "col-span-2 md:col-span-1" }
const _hoisted_16 = { class: "col-span-1 flex flex-col gap-2 items-start px-4 py-5" }
const _hoisted_17 = {
  key: 0,
  class: "text-theme-error"
}
const _hoisted_18 = { class: "grid grid-cols-2 md:divide-x divide-y md:divide-y-0 divide-theme-gray-7 border-t border-theme-gray-7" }
const _hoisted_19 = { class: "col-span-2 md:col-span-1 flex flex-col gap-2 items-start px-4 py-5" }
const _hoisted_20 = {
  key: 0,
  class: "text-theme-error"
}
const _hoisted_21 = { class: "col-span-2 md:col-span-1" }
const _hoisted_22 = { class: "col-span-1 flex flex-col gap-2 items-start px-4 py-5 relative" }
const _hoisted_23 = {
  key: 0,
  class: "text-theme-error"
}
const _hoisted_24 = { class: "grid grid-cols-2 md:divide-x divide-y md:divide-y-0 divide-theme-gray-7 border-t border-theme-gray-7" }
const _hoisted_25 = { class: "col-span-2 md:col-span-1 flex flex-col gap-2 items-start px-4 py-5" }
const _hoisted_26 = {
  key: 0,
  class: "text-theme-error"
}
const _hoisted_27 = { class: "col-span-2 md:col-span-1 flex flex-col gap-2 items-start px-4 py-5" }
const _hoisted_28 = {
  key: 0,
  class: "text-theme-error"
}
const _hoisted_29 = {
  key: 0,
  class: "flex flex-col border-t border-theme-gray-7 bg-amber-50/50 p-5"
}
const _hoisted_30 = { class: "flex items-start gap-3" }
const _hoisted_31 = { class: "flex-1" }
const _hoisted_32 = { class: "text-slate-600 text-xs mt-1" }
const _hoisted_33 = { class: "text-slate-900" }
const _hoisted_34 = { class: "text-slate-600 text-xs mt-0.5" }
const _hoisted_35 = {
  key: 0,
  class: "mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"
}
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "text-slate-900 font-bold text-xs truncate text-center" }
const _hoisted_38 = { class: "text-slate-500 text-[10px] text-center uppercase tracking-wider mb-2" }
const _hoisted_39 = { class: "flex justify-center gap-3 text-xs text-slate-600 mb-3" }
const _hoisted_40 = { class: "inline-flex items-center gap-1" }
const _hoisted_41 = { class: "inline-flex items-center gap-1" }
const _hoisted_42 = { class: "text-center font-bold text-slate-900 text-sm mb-3" }
const _hoisted_43 = ["onClick", "disabled"]
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = {
  key: 1,
  class: "mt-4 p-4 bg-amber-50 border border-amber-200 rounded-2xl text-center text-xs text-amber-800"
}
const _hoisted_47 = { class: "flex flex-col border-t border-theme-gray-7" }
const _hoisted_48 = { class: "col-span-1 flex flex-col gap-2 items-start px-4 py-5" }
const _hoisted_49 = {
  key: 1,
  class: "flex items-center gap-2 px-4 py-3 bg-theme-gray-7/30 border-t border-theme-gray-7"
}
const _hoisted_50 = {
  key: 0,
  class: "flex gap-4 mt-6"
}
const _hoisted_51 = {
  key: 1,
  class: "flex flex-col mt-6 border border-theme-gray-7 rounded-2xl overflow-hidden"
}
const _hoisted_52 = { class: "flex flex-col" }
const _hoisted_53 = { class: "grid grid-cols-2 md:divide-x divide-y md:divide-y-0 divide-theme-gray-7" }
const _hoisted_54 = { class: "col-span-2 md:col-span-1 flex flex-col gap-2 items-start px-4 py-5" }
const _hoisted_55 = {
  key: 0,
  class: "text-theme-error"
}
const _hoisted_56 = { class: "col-span-2 md:col-span-1" }
const _hoisted_57 = { class: "col-span-1 flex flex-col gap-2 items-start px-4 py-5" }
const _hoisted_58 = {
  key: 0,
  class: "text-theme-error"
}
const _hoisted_59 = { class: "grid grid-cols-2 md:divide-y divide-y md:divide-y-0 divide-theme-gray-7 border-t border-theme-gray-7" }
const _hoisted_60 = { class: "col-span-2 md:col-span-1 flex flex-col gap-2 items-start px-4 py-5 border-r border-theme-gray-7" }
const _hoisted_61 = {
  key: 0,
  class: "text-theme-error"
}
const _hoisted_62 = { class: "col-span-2 md:col-span-1 flex flex-col gap-2 items-start px-4 py-5" }
const _hoisted_63 = {
  key: 0,
  class: "text-theme-error"
}
const _hoisted_64 = { class: "flex gap-4 w-full pt-1" }
const _hoisted_65 = { class: "flex flex-col flex-1 gap-1" }
const _hoisted_66 = ["value"]
const _hoisted_67 = { class: "flex flex-col flex-1 gap-1" }
const _hoisted_68 = ["value"]
const _hoisted_69 = {
  key: 0,
  class: "text-theme-error p-4"
}
const _hoisted_70 = {
  key: 2,
  class: "flex flex-col mt-6 border border-theme-gray-7 rounded-2xl overflow-hidden bg-slate-50"
}
const _hoisted_71 = { class: "p-6 flex flex-col gap-4 text-left" }
const _hoisted_72 = { class: "flex justify-between items-center bg-white p-4 rounded-xl border border-slate-100 shadow-sm" }
const _hoisted_73 = { class: "text-2xl font-black text-slate-800 pt-1" }
const _hoisted_74 = {
  key: 0,
  class: "flex gap-3 items-center bg-emerald-50 border border-emerald-100 p-4 rounded-xl text-emerald-800 text-xs"
}
const _hoisted_75 = {
  key: 1,
  class: "flex gap-3 items-center bg-rose-50 border border-rose-100 p-4 rounded-xl text-rose-800 text-xs"
}
const _hoisted_76 = {
  key: 2,
  class: "text-theme-error font-semibold text-sm"
}
const _hoisted_77 = {
  key: 3,
  class: "flex flex-col mt-6 border border-theme-gray-7 rounded-lg overflow-hidden"
}
const _hoisted_78 = {
  key: 0,
  class: "p-5 flex flex-col bg-white"
}
const _hoisted_79 = { class: "flex flex-col md:flex-row gap-4" }
const _hoisted_80 = { class: "flex-1 w-full text-left" }
const _hoisted_81 = ["disabled"]
const _hoisted_82 = {
  key: 0,
  class: "mt-2 text-theme-error text-sm font-semibold"
}
const _hoisted_83 = ["disabled"]
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = {
  key: 4,
  class: "mt-8 p-6 bg-slate-50 rounded-2xl border border-slate-100 flex flex-col gap-3"
}
const _hoisted_87 = { class: "flex justify-between items-center text-slate-600 font-medium" }
const _hoisted_88 = { class: "font-bold tracking-tight" }
const _hoisted_89 = {
  key: 0,
  class: "flex justify-between items-center text-emerald-600 font-medium"
}
const _hoisted_90 = { class: "font-bold tracking-tight" }
const _hoisted_91 = { class: "flex justify-between items-center" }
const _hoisted_92 = { class: "text-2xl font-black text-theme-active" }
const _hoisted_93 = { class: "flex flex-col md:flex-row items-center gap-4 mt-12" }
const _hoisted_94 = { class: "text-theme-gray-2" }
const _hoisted_95 = { key: 0 }
const _hoisted_96 = { key: 1 }

import { ref, computed, watch, onMounted, onBeforeMount, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import BookingSummary from '@/components/BookingSummary.vue'
import CountrySearchablePhoneField from '@/components/CountrySearchablePhoneField.vue'
import { getPaymentSession, getSessionPrefix, handleApiError, isLoggedIn, isValidCardNumber, isValidEmail, resetErrors, savePaymentSession, savePaymentWallet, getBackendBaseUrl, getUserToken } from '@/utils/common'
import CarService from '@/services/car-service'
import { Car as CarData, UserSearch } from '@/types'
import { retrieveUserSearch } from '@/services/search-service'
import BookingService from '@/services/booking-service'
import Payment from '@/composables/Payment'
import { credimax } from '@/utils/constants'
import creditCardType from 'credit-card-type'
import axios from 'axios'
import Car from '@/composables/Car'
import { NotificationType } from '@/types'
import Notification from '@/widgets/Notification.vue'
import { useCoupon } from '@/composables/Coupon'
import sClassImg from '@/assets/cars/luxury-sedan.png'
import vClassImg from '@/assets/cars/van.png'
import eClassImg from '@/assets/cars/premium-sedan.png'
import gmcSuvImg from '@/assets/cars/suv.png'

declare global {
  interface Window {
    ThreeDS: any;
  }
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactDetails',
  props: ['currentStep'],
  setup(__props) {

const props = __props
const { retrieveUserSelectedCar, saveSelectedCar } = CarService()
const notif = ref<NotificationType>({ show: false, type: 'success', message: '', messageDetails: ''})
const { updateBooking, createBooking } = BookingService()
const { createToken, createSession, updateSession, initiateAuthentication, authenticatePayer: authenticatePayerService, authorizePayment } = Payment()
const authUser = isLoggedIn()
const isLogged = ref(!!authUser)

const router = useRouter()
const baseUrl = getBackendBaseUrl()

const agencyWallet = ref<any>({
   allow_wallet_booking: false,
   wallet_balance: 0.0,
   wallet_currency: 'USD',
   booking_amount: 0.0,
   has_sufficient_balance: false
})
const selectedPaymentMethod = ref<'card' | 'wallet'>('card')
const isWalletLoading = ref<boolean>(false)

const fetchAgencyWalletInfo = async (bookingNumber: string) => {
   if (!isLogged.value || authUser?.user?.type !== 'agent') return
   
   isWalletLoading.value = true
   try {
      const response = await axios.get(baseUrl + 'api/credit/agency-wallet/' + bookingNumber, {
         headers: {
            'Authorization': `Bearer ${getUserToken()}`,
            'Content-Type': 'application/json'
         }
      })
      if (response.status === 200 && response.data.success) {
         agencyWallet.value = response.data
      }
   } catch (error) {
      console.error('Failed to load agency wallet info:', error)
   } finally {
      isWalletLoading.value = false
   }
}

const contactDetails = ref<any>({
   firstName: '',
   phoneNumber: '',
   lastName: '',
   email: '',
   comments: '',
   passengers: null,
   bags: null,
   createAccount: false,
   needConfirmation: false
})
const paymentDetails = ref<any>({
   card: {
      name: '',
      number: '',
      cvc: '',
      expiration: ''
   },
   token: '',
   session: null,
   order: null,
   transaction: null
})
const errors = ref<any>({
   firstName: null,
   lastName: null,
   email: null,
   phoneNumber: null,
   cardName: null,
   cardNumber: null,
   cardCVC: null,
   cardExpiration: null,
   responseError: null
})
const isLoading = ref<boolean>(false)
const show3DS = ref<boolean>(false)

// Coupon Logic
const { applyCoupon: apiApply, validateCoupon } = useCoupon()
const showPromo = ref(false)
const promoCode = ref('')
const promoErrorMessage = ref('')
const isApplyingPromo = ref(false)
const appliedDiscount = ref<number | undefined>(undefined)
const newTotal = ref<number | undefined>(undefined)

const car = ref<CarData>(retrieveUserSelectedCar())
const carPrice = computed(() => car.value ? car.value.price : 0)
const userSearch = ref<UserSearch | null>(retrieveUserSearch())

const summaryKey = ref(0)
const isSwitchingCar = ref(false)
const switchingCarId = ref<number | null>(null)

const showUpgradeSuggestions = computed(() => {
   if (!car.value) return false
   const maxPax = car.value.type?.passengers || 0
   const maxBags = car.value.type?.bags || 0
   const enteredPax = parseInt(contactDetails.value.passengers) || 0
   const enteredBags = parseInt(contactDetails.value.bags) || 0
   
   return (enteredPax > 0 && enteredPax > maxPax) || (enteredBags > 0 && enteredBags > maxBags)
})

const getCarImage = (c: CarData) => {
   if (c.image && c.image !== '' && !c.image.includes('default.jpg')) {
      return c.image
   }
   const name = (c.type?.name || '').toLowerCase()
   if (name.includes('premium')) return eClassImg
   if (name.includes('luxury')) return sClassImg
   if (name.includes('van')) return vClassImg
   if (name.includes('suv')) return gmcSuvImg
   if (name.includes('bus')) return '/assets/busescoaches.jpeg'
   
   return '/assets/nocarfound.jpeg'
}

const suggestedCars = computed(() => {
   if (!showUpgradeSuggestions.value) return []
   const prefix = getSessionPrefix()
   const allSearched: CarData[] = JSON.parse(localStorage.getItem(`${prefix}_searched_cars`) || '[]')
   
   const enteredPax = parseInt(contactDetails.value.passengers) || 0
   const enteredBags = parseInt(contactDetails.value.bags) || 0
   
   return allSearched.filter(c => {
      // Exclude the current car
      if (c.id === car.value?.id) return false
      
      const paxCapacity = c.type?.passengers || 0
      const bagCapacity = c.type?.bags || 0
      
      // If they entered passenger count, target car must fit the passenger count
      if (enteredPax > 0 && paxCapacity < enteredPax) return false
      // If they entered bag count, target car must fit the bag count
      if (enteredBags > 0 && bagCapacity < enteredBags) return false
      
      return true
   })
})

const switchCar = async (newCar: CarData) => {
   isSwitchingCar.value = true
   switchingCarId.value = newCar.id
   try {
      const searchData = userSearch.value || retrieveUserSearch()
      const response = await createBooking(newCar, searchData as UserSearch)
      if (response.success) {
         saveSelectedCar(newCar)
         const prefix = getSessionPrefix()
         localStorage.setItem(`${prefix}_booking_number`, response.data.data.number)
         
         // Update local states
         car.value = newCar
         appliedDiscount.value = undefined
         newTotal.value = undefined
         promoCode.value = ''
         promoErrorMessage.value = ''
         summaryKey.value++
         
         notif.value = { 
            show: true, 
            type: 'success', 
            message: 'Vehicle Switched', 
            messageDetails: `Successfully upgraded to ${newCar.name} (${newCar.type?.name}).` 
         }
      } else {
         notif.value = { show: true, type: 'error', message: 'Switch Failed', messageDetails: typeof response.error === 'string' ? response.error : (response.error as any)?.message || 'Failed to switch vehicle.' }
      }
   } catch (err: any) {
      console.error(err)
      notif.value = { show: true, type: 'error', message: 'Error', messageDetails: 'An error occurred while switching vehicle.' }
   } finally {
      isSwitchingCar.value = false
      switchingCarId.value = null
   }
}

watch([showUpgradeSuggestions, suggestedCars, car], ([hasSuggestions, list, currentCar]) => {
   const isInitiallyOnRequest = Number(currentCar?.price || 0) <= 0
   if (isInitiallyOnRequest) {
      contactDetails.value.needConfirmation = true
   } else {
      contactDetails.value.needConfirmation = hasSuggestions && list.length === 0
   }
}, { immediate: true })

const togglePromo = () => {
    showPromo.value = !showPromo.value
    promoErrorMessage.value = ''
}

const applyPromoCode = async () => {
    isApplyingPromo.value = true
    const prefix = getSessionPrefix()
    const bookingNumber = localStorage.getItem(`${prefix}_booking_number`)

    if (!bookingNumber) {
        notif.value = { show: true, type: 'error', message: 'Error', messageDetails: 'Missing booking reference.' }
        isApplyingPromo.value = false
        return
    }

    if (!contactDetails.value.email) {
         notif.value = { show: true, type: 'warning', message: 'Email Required', messageDetails: 'Please enter your email address first to apply coupons.' }
         isApplyingPromo.value = false
         return
    }

    const { applyCoupon: apiApply, validateCoupon } = useCoupon()
    
    // First Validate against customer constraints
    const car: CarData = retrieveUserSelectedCar()
    const baseAmount = car ? car.price : 0
    
    const validRes = await validateCoupon(promoCode.value, contactDetails.value.email, baseAmount)
    if (validRes.status !== 'success') {
        promoErrorMessage.value = validRes.message
        isApplyingPromo.value = false
        return
    }

    // Now securely apply to DB
    const res = await apiApply(promoCode.value, bookingNumber)
    
    if (res.status === 'success') {
       promoErrorMessage.value = '' // ✅ Clear any old error message
       notif.value = { show: true, type: 'success', message: 'Offer Applied', messageDetails: res.data.message }
       appliedDiscount.value = res.data.discount_amount
       newTotal.value = res.data.new_total
    } else {
       notif.value = { show: true, type: 'error', message: 'Failed to apply coupon', messageDetails: res.message }
    }
    
    isApplyingPromo.value = false
}

// Expiry Dropdowns
const expiryMonth = ref('')
const expiryYear = ref('')

const updateExpiry = () => {
   if (expiryMonth.value && expiryYear.value) {
      paymentDetails.value.card.expiration = `${expiryYear.value}-${expiryMonth.value}`
   }
}

const handleBookingProceed = async () => {
      
      resetErrors(errors.value)
      if (!validateForm()) {
         notif.value = { show: true, type: 'error', message: 'Incomplete Details', messageDetails: 'Please fill in all required fields (marked in red) before proceeding.' }
         return
      }

      if (showUpgradeSuggestions.value && suggestedCars.value.length > 0) {
         notif.value = { 
            show: true, 
            type: 'error', 
            message: 'Capacity Exceeded', 
            messageDetails: 'Please upgrade to one of the suggested vehicles with sufficient passenger and luggage capacity above.' 
         }
         return
      }

      const prefix = getSessionPrefix()
      const bookingNumber = localStorage.getItem(`${prefix}_booking_number`)

      isLoading.value = true

      // ✅ 1. Sync backend
      const response = await updateBooking(bookingNumber as string, contactDetails.value, paymentDetails.value, contactDetails.value.needConfirmation)
      
      if (response.success) {
         if (contactDetails.value.needConfirmation) {
            isLoading.value = false
            router.push({name: 'BookingWizard', params: {step: 'finish'}})
         } else if (selectedPaymentMethod.value === 'wallet') {
            // WALLET DIRECT DEDUCTION PATH
            try {
               const payResponse = await axios.post(baseUrl + 'api/credit/agency-wallet/pay', {
                  booking: bookingNumber
               }, {
                  headers: {
                     'Authorization': `Bearer ${getUserToken()}`,
                     'Content-Type': 'application/json'
                  }
               })
               if (payResponse.status === 200 && payResponse.data.success) {
                  savePaymentWallet('wallet')
                  router.push({ 
                     name: 'BookingWizard', 
                     params: { step: 'finish' },
                     query: { status: 'success' }
                  })
               } else {
                  isLoading.value = false
                  errors.value.responseError = payResponse.data?.message || 'Failed to complete payment using wallet credits.'
               }
            } catch (err: any) {
               isLoading.value = false
               errors.value.responseError = err.response?.data?.message || 'Error occurred during wallet credit deduction.'
            }
         } else {
            // DIRECT PAYMENT PATH
            savePaymentWallet('card')
            paymentDetails.value.card.brand = getCardBrand(paymentDetails.value.card.number.toString())
            paymentDetails.value.order = bookingNumber

            const tokenResponse = await createToken(paymentDetails.value)
            if (tokenResponse.status == 201) {

               const sessionResponse = await updateSession(paymentDetails.value.session, tokenResponse.data.token, bookingNumber as string)
               
               if (sessionResponse.status == 200 && sessionResponse.data.success) {
                  paymentDetails.value.transaction = sessionResponse.data.transaction
                  initiate3DSAuthentication(paymentDetails.value.order, paymentDetails.value.transaction)
               } else {
                  isLoading.value = false
                  // Show real error from bank if available, otherwise fallback
                  const bankError = sessionResponse.data?.error?.explanation || sessionResponse.data?.error?.message
                  errors.value.responseError = bankError 
                    ? `Bank Error: ${bankError}` 
                    : 'Payment authorization setup failed. Please check your card details or try another card.'
                  
                  console.error('Session Update Failed:', sessionResponse.data)
               }

            } else {
               isLoading.value = false
               errors.value.responseError = 'Card validation failed. Please check your card number.'
            }
         }
      } else {
         isLoading.value = false
         const error = handleApiError(response)
         errors.value.responseError = error
      }
}

const validateForm = () => {
   
   let response = true
   
   if (contactDetails.value.firstName === '') {
      errors.value.firstName = true
      response = false
   }
   
   if (contactDetails.value.lastName === '') {
      errors.value.lastName = true
      response = false
   }
   
   if (contactDetails.value.phoneNumber === '') {
      errors.value.phoneNumber = 'Required'
      response = false
   }else if (contactDetails.value.phoneNumber.length < 11) {
      errors.value.phoneNumber = 'Invalid'
      response = false
   }

   if (contactDetails.value.email === '') {
      errors.value.email = 'Required'
      response = false
   } else if (!isValidEmail(contactDetails.value.email)) {
      errors.value.email = 'Invalid'
      response = false
   }
   
   if (!contactDetails.value.passengers) {
      errors.value.passengers = true
      response = false
   }

   if (contactDetails.value.bags === null || contactDetails.value.bags === undefined) {
      errors.value.bags = true
      response = false
   }
   
   if (contactDetails.value.needConfirmation === false && selectedPaymentMethod.value === 'card') {
      
      if (paymentDetails.value.card.name === '') {
         errors.value.cardName = true
         response = false
      }
   
      if (paymentDetails.value.card.number === '') {
         errors.value.cardNumber = 'Required'
         response = false
      } else if (!isValidCardNumber(paymentDetails.value.card.number)) {
         errors.value.cardNumber = 'Invalid'
         response = false
      }
   
      if (paymentDetails.value.card.cvc === '') {
         errors.value.cardCVC = true
         response = false
      }
   
      if (paymentDetails.value.card.expiration === '') {
         errors.value.cardExpiration = true
         response = false
      }
   }

   return response
}

const handlePhoneChange = (value: string) => {
   contactDetails.value.phoneNumber = value
}

const getPaymentToken = async () : Promise<any> => {

   let paymentToken

   /* Todo : generate a valid payment token from payment gateway */
   paymentToken = '123456789abcef'

   return { success: true, token: paymentToken }
}

const getCardBrand = (cardNumber: string) => {
   const cardType = creditCardType(cardNumber);

   if (cardType.length > 0) {
      return cardType[0].niceType
   }

   return 'Unknown'
}

onMounted(async () => {
   if (!car.value || !userSearch.value) {
      router.push('/')
      return
   }

   if (isLogged.value && authUser?.user && authUser.user.type === 'web') {
      contactDetails.value.firstName = authUser.user.firstName || ''
      contactDetails.value.lastName = authUser.user.lastName || ''
      contactDetails.value.email = authUser.user.email || ''
   }

   const response: any = retrieveUserSelectedCar()
   if (response && (response.price === null || response.price === 0 || response.price === 'on-request' || response.needConfirmation === true)) {
      contactDetails.value.needConfirmation = true
   }

   if (!contactDetails.value.needConfirmation) {
      const sessionResponse = await checkAndCreateSession()
      if (!sessionResponse.status) {
         notif.value = { show: true, type: 'error', message: 'Error', messageDetails: 'Payment cannot be processed at the moment'}
      } else {
         paymentDetails.value.session = sessionResponse.session
      }
      const prefix = getSessionPrefix()
      const bookingNumber = localStorage.getItem(`${prefix}_booking_number`)
      if (bookingNumber) {
         await fetchAgencyWalletInfo(bookingNumber)
      }
   }

   window.addEventListener('message', handlePaymentMessage)
})

onUnmounted(() => {
   window.removeEventListener('message', handlePaymentMessage)
})

const handlePaymentMessage = async (event: MessageEvent) => {
   if (event.data === 'redirect') {
      show3DS.value = false
      isLoading.value = true
      
      // Final Step: Authorize and Capture the payment
      console.log('Completing Payment with:', {
         session: paymentDetails.value.session,
         order: paymentDetails.value.order,
         transaction: paymentDetails.value.transaction,
         cvc: paymentDetails.value.card.cvc
      })
      const response = await authorizePayment(
         paymentDetails.value.session,
         paymentDetails.value.order,
         paymentDetails.value.transaction.toString(),
         paymentDetails.value.card.cvc.toString()
      )

      if (response.status === 200 && response.data.success) {
         // Redirect to success page with a success flag
         router.push({ 
            name: 'BookingWizard', 
            params: { step: 'finish' },
            query: { status: 'success' }
         })
      } else {
         isLoading.value = false
         notif.value = { 
            show: true, 
            type: 'error', 
            message: 'Payment Error', 
            messageDetails: response.data?.error?.explanation || response.data?.error || 'Payment authorization failed. Please contact support.' 
         }
      }
   } else if (event.data === 'error') {
      show3DS.value = false
      isLoading.value = false
      notif.value = { show: true, type: 'error', message: 'Payment Error', messageDetails: 'Authentication failed. Please try again.' }
   }
}

onBeforeMount(() => {
   const script = document.createElement('script')
   script.src = credimax.sdk
   script.dataset.error = 'errorCallback'
   script.dataset.cancel = 'cancelCallback'
   script.onload = async () => {
      const response = await configure3DS()
      if (!response) {
         notif.value = { show: true, type: 'error', message: 'Error', messageDetails: 'Payment partner configuration error'}
      }
   }
   document.head.appendChild(script)
})

const configure3DS = (): Promise<boolean> => {
   return new Promise((resolve, reject) => {
      window.ThreeDS.configure({
         merchantId: credimax.merchant_id,
         sessionId: paymentDetails.value.session,
         containerId: '3DSUI',
         callback: function () {
            resolve(window.ThreeDS.isConfigured())
         },
         configuration: {
            userLanguage: 'en-AU',
            wsVersion: 77,
         },
      })
   })
}

const initiate3DSAuthentication = async (order: string, transaction: string) => {

   if (!window.ThreeDS.isConfigured()) {
      await configure3DS()
   }

   const car : CarData = retrieveUserSelectedCar()
   const totalAmount = car ? car.price : 0

   const sessionResponse = await initiateAuthentication(paymentDetails.value.session, paymentDetails.value.order, paymentDetails.value.transaction)
   
   if (sessionResponse.status === 200) {
      const data = sessionResponse.data.response
      const recommendation = data.response ? data.response.gatewayRecommendation : data.gatewayRecommendation
      if (recommendation == 'PROCEED') {
         authenticatePayerLocal(order, transaction)
      } else {
         isLoading.value = false
         notif.value = { show: true, type: 'error', message: 'Error', messageDetails: 'Payment could not be initiated: ' + recommendation}
      }
   } else {
      isLoading.value = false
      notif.value = { show: true, type: 'error', message: 'Error', messageDetails: 'Server error during payment initiation'}
   }
}

const authenticatePayerLocal = async (order: string, transaction: string) => {

   isLoading.value = true
   const response = await authenticatePayerService(paymentDetails.value.session, order, transaction)
   if (response.status === 200) {
      const data = response.data.response
      if (data.authentication && data.authentication.redirect) {
         isLoading.value = false // Stop main loading before showing 3DS
         show3DS.value = true
         const html = data.authentication.redirect.html
         setTimeout(() => {
            const container = document.getElementById('3DSUI')
            if (container) {
               container.innerHTML = html
               const form = container.querySelector('form')
               if (form) form.submit()
            }
         }, 100)
      } else {
         isLoading.value = false
      }
   } else {
      isLoading.value = false
      notif.value = { show: true, type: 'error', message: 'Error', messageDetails: 'Failed to connect to bank. Please try again.'}
   }
}


const checkAndCreateSession = async () : Promise<{status: boolean, session: string | null}> => {

   const sessionResponse = await createSession()
   if (sessionResponse.status == 200) {
      savePaymentSession(sessionResponse.data.session)
      return {status: true, session: sessionResponse.data.session}
   } else {
      return {status: false, session: null}
   }
}

const notifClosed = () : void => {
   notif.value.show = false
}


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (show3DS.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (show3DS.value = false)),
            class: "absolute inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity"
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "text-lg font-bold text-slate-900" }, "Secure Payment", -1)),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (show3DS.value = false)),
                class: "rounded-full p-2 hover:bg-slate-100 transition-colors"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-xmark",
                  class: "text-slate-500"
                })
              ])
            ]),
            _cache[21] || (_cache[21] = _createElementVNode("div", {
              id: "3DSUI",
              class: "max-h-[80vh] w-full overflow-y-auto bg-white p-6 shadow-inner"
            }, null, -1))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createBlock(BookingSummary, {
          key: summaryKey.value,
          currentStep: __props.currentStep,
          couponDiscount: appliedDiscount.value,
          newTotal: newTotal.value
        }, null, 8, ["currentStep", "couponDiscount", "newTotal"]))
      ]),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[22] || (_cache[22] = [
            _createElementVNode("div", { class: "bg-white p-8 rounded-3xl shadow-2xl flex flex-col items-center gap-4 max-w-sm text-center border border-slate-100" }, [
              _createElementVNode("div", { class: "w-16 h-16 border-4 border-theme-active border-t-transparent rounded-full animate-spin" }),
              _createElementVNode("h3", { class: "text-xl font-bold text-slate-900" }, "Processing Payment"),
              _createElementVNode("p", { class: "text-slate-600" }, "Securely connecting to your bank. Please do not refresh the page...")
            ], -1)
          ])))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (!isLogged.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Guest "))
              : _createCommentVNode("", true),
            _cache[23] || (_cache[23] = _createTextVNode("Contact details "))
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", {
                  class: _normalizeClass([!errors.value.firstName ? 'text-theme-gray-2' : 'text-theme-error', "uppercase text-small flex items-center gap-1"])
                }, [
                  _cache[24] || (_cache[24] = _createElementVNode("span", null, "First name *", -1)),
                  (errors.value.firstName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "(required)"))
                    : _createCommentVNode("", true)
                ], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((contactDetails.value.firstName) = $event)),
                  type: "text",
                  class: "outline-none w-full h-30 font-bold text-size-6 border-none",
                  placeholder: "Enter first name"
                }, null, 512), [
                  [_vModelText, contactDetails.value.firstName]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", {
                    class: _normalizeClass([!errors.value.lastName ? 'text-theme-gray-2' : 'text-theme-error', "uppercase text-small flex items-center gap-1"])
                  }, [
                    _cache[25] || (_cache[25] = _createElementVNode("span", null, "Last name *", -1)),
                    (errors.value.lastName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, "(required)"))
                      : _createCommentVNode("", true)
                  ], 2),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((contactDetails.value.lastName) = $event)),
                    type: "text",
                    class: "outline-none w-full h-30 font-bold text-size-6 border-none",
                    placeholder: "Enter last name"
                  }, null, 512), [
                    [_vModelText, contactDetails.value.lastName]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", {
                  class: _normalizeClass([!errors.value.email ? 'text-theme-gray-2' : 'text-theme-error', "uppercase text-small flex items-center gap-1"])
                }, [
                  _cache[26] || (_cache[26] = _createElementVNode("span", null, "Email *", -1)),
                  (errors.value.email)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, "(" + _toDisplayString(errors.value.email) + ")", 1))
                    : _createCommentVNode("", true)
                ], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((contactDetails.value.email) = $event)),
                  type: "text",
                  class: "outline-none w-full h-30 font-bold text-size-6 border-none",
                  placeholder: "Enter email address"
                }, null, 512), [
                  [_vModelText, contactDetails.value.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", {
                    class: _normalizeClass([!errors.value.phoneNumber ? 'text-theme-gray-2' : 'text-theme-error', "uppercase text-small flex items-center gap-1"])
                  }, [
                    _cache[27] || (_cache[27] = _createElementVNode("span", null, "Phone number *", -1)),
                    (errors.value.phoneNumber)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, "(" + _toDisplayString(errors.value.phoneNumber) + ")", 1))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createVNode(CountrySearchablePhoneField, { onPhoneNumber: handlePhoneChange })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", {
                  class: _normalizeClass([!errors.value.passengers ? 'text-theme-gray-2' : 'text-theme-error', "uppercase text-small flex items-center gap-1"])
                }, [
                  _cache[28] || (_cache[28] = _createElementVNode("span", null, "No. of passengers *", -1)),
                  (errors.value.passengers)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, "(required)"))
                    : _createCommentVNode("", true)
                ], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((contactDetails.value.passengers) = $event)),
                  type: "number",
                  class: "outline-none w-full h-30 font-bold text-size-6 border-none placeholder:font-normal placeholder:text-gray-400 placeholder:opacity-60",
                  placeholder: "e.g. 2"
                }, null, 512), [
                  [_vModelText, contactDetails.value.passengers]
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", {
                  class: _normalizeClass([!errors.value.bags ? 'text-theme-gray-2' : 'text-theme-error', "uppercase text-small flex items-center gap-1"])
                }, [
                  _cache[29] || (_cache[29] = _createElementVNode("span", null, "No. of bags *", -1)),
                  (errors.value.bags)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_28, "(required)"))
                    : _createCommentVNode("", true)
                ], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((contactDetails.value.bags) = $event)),
                  type: "number",
                  class: "outline-none w-full h-30 font-bold text-size-6 border-none placeholder:font-normal placeholder:text-gray-400 placeholder:opacity-60",
                  placeholder: "e.g. 1"
                }, null, 512), [
                  [_vModelText, contactDetails.value.bags]
                ])
              ])
            ]),
            (showUpgradeSuggestions.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _cache[38] || (_cache[38] = _createElementVNode("span", { class: "text-xl leading-none" }, "⚠️", -1)),
                    _createElementVNode("div", _hoisted_31, [
                      _cache[37] || (_cache[37] = _createElementVNode("h4", { class: "text-amber-800 font-bold text-sm uppercase" }, "Capacity Limit Warning", -1)),
                      _createElementVNode("p", _hoisted_32, [
                        _cache[30] || (_cache[30] = _createTextVNode(" The selected ")),
                        _createElementVNode("strong", _hoisted_33, _toDisplayString(car.value?.name), 1),
                        _cache[31] || (_cache[31] = _createTextVNode(" can carry a maximum of ")),
                        _createElementVNode("strong", null, _toDisplayString(car.value?.type?.passengers) + " passengers", 1),
                        _cache[32] || (_cache[32] = _createTextVNode(" and ")),
                        _createElementVNode("strong", null, _toDisplayString(car.value?.type?.bags) + " bags", 1),
                        _cache[33] || (_cache[33] = _createTextVNode(". "))
                      ]),
                      _createElementVNode("p", _hoisted_34, [
                        _cache[34] || (_cache[34] = _createTextVNode(" Since you entered ")),
                        _createElementVNode("strong", null, _toDisplayString(contactDetails.value.passengers) + " passengers", 1),
                        _cache[35] || (_cache[35] = _createTextVNode(" and ")),
                        _createElementVNode("strong", null, _toDisplayString(contactDetails.value.bags) + " bags", 1),
                        _cache[36] || (_cache[36] = _createTextVNode(", please select a vehicle with suitable capacity below: "))
                      ])
                    ])
                  ]),
                  (suggestedCars.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestedCars.value, (sCar) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: sCar.id,
                            class: "flex flex-col border border-amber-200 rounded-2xl p-4 bg-white shadow-sm hover:border-amber-400 hover:shadow transition-all"
                          }, [
                            _createElementVNode("img", {
                              src: getCarImage(sCar),
                              class: "h-20 object-contain mx-auto mb-2",
                              alt: "vehicle"
                            }, null, 8, _hoisted_36),
                            _createElementVNode("h5", _hoisted_37, _toDisplayString(sCar.name), 1),
                            _createElementVNode("p", _hoisted_38, _toDisplayString(sCar.type?.name), 1),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("span", _hoisted_40, "👤 " + _toDisplayString(sCar.type?.passengers), 1),
                              _createElementVNode("span", _hoisted_41, "🧳 " + _toDisplayString(sCar.type?.bags), 1)
                            ]),
                            _createElementVNode("div", _hoisted_42, _toDisplayString(sCar.price > 0 ? `${(userSearch.value?.currency || '$')} ${sCar.price.toFixed(2)}` : 'On Request'), 1),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (switchCar(sCar)),
                              disabled: isSwitchingCar.value,
                              class: "w-full text-center bg-amber-500 hover:bg-amber-600 disabled:bg-slate-300 text-[#0a0d0f] font-bold text-xs py-2 px-3 rounded-full transition-colors"
                            }, [
                              (isSwitchingCar.value && switchingCarId.value === sCar.id)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_44, " Switching... "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_45, " Switch to this car "))
                            ], 8, _hoisted_43)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_46, _cache[39] || (_cache[39] = [
                        _createTextVNode(" No pre-priced vehicles are currently available with this capacity in our system. "),
                        _createElementVNode("strong", null, "You can proceed with this booking as a \"Request a Quote\" booking request", -1),
                        _createTextVNode(". Our operations team will manually assign a suitable vehicle and quote you the price. ")
                      ])))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _cache[40] || (_cache[40] = _createElementVNode("div", { class: "uppercase text-theme-gray-2 text-small" }, "Comments", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((contactDetails.value.comments) = $event)),
                  autocomplete: "off",
                  name: "booking_comments",
                  class: "outline-none w-full h-30 font-bold text-size-6 border-none h-[60px] placeholder:font-normal placeholder:text-gray-400 placeholder:opacity-60",
                  placeholder: "Extra requirements or special notes (e.g. child seat, wheelchair etc.)"
                }, null, 512), [
                  [_vModelText, contactDetails.value.comments]
                ])
              ])
            ]),
            (!isLogged.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((contactDetails.value.createAccount) = $event)),
                    type: "checkbox",
                    id: "create-account",
                    class: "w-4 h-4 rounded border-gray-300 text-theme-active focus:ring-theme-active cursor-pointer"
                  }, null, 512), [
                    [_vModelCheckbox, contactDetails.value.createAccount]
                  ]),
                  _cache[41] || (_cache[41] = _createElementVNode("label", {
                    for: "create-account",
                    class: "text-[10px] md:text-small font-bold text-theme-gray-2 uppercase cursor-pointer select-none"
                  }, " Save my details and create an account to track my booking ", -1))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (isLogged.value && _unref(authUser)?.user?.type === 'agent' && agencyWallet.value.allow_wallet_booking && !contactDetails.value.needConfirmation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
              _createElementVNode("button", {
                onClick: _cache[9] || (_cache[9] = ($event: any) => (selectedPaymentMethod.value = 'card')),
                class: _normalizeClass([selectedPaymentMethod.value === 'card' ? 'border-theme-active bg-theme-active/5 text-theme-active font-black' : 'border-theme-gray-7 bg-white text-slate-500 font-bold', "flex-1 py-4 px-6 border-2 rounded-2xl flex items-center justify-center gap-3 transition-all duration-300 cursor-pointer"])
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-credit-card" }),
                _cache[42] || (_cache[42] = _createElementVNode("span", { class: "uppercase text-size-2" }, "Pay by Credit Card", -1))
              ], 2),
              _createElementVNode("button", {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (selectedPaymentMethod.value = 'wallet')),
                class: _normalizeClass([selectedPaymentMethod.value === 'wallet' ? 'border-theme-active bg-theme-active/5 text-theme-active font-black' : 'border-theme-gray-7 bg-white text-slate-500 font-bold', "flex-1 py-4 px-6 border-2 rounded-2xl flex items-center justify-center gap-3 transition-all duration-300 cursor-pointer"])
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-wallet" }),
                _cache[43] || (_cache[43] = _createElementVNode("span", { class: "uppercase text-size-2" }, "Pay by Agency Wallet", -1))
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (!contactDetails.value.needConfirmation && selectedPaymentMethod.value === 'card')
          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
              _cache[52] || (_cache[52] = _createElementVNode("div", { class: "bg-theme-gray-7 px-5 py-3.5 text-theme-gray-2 text-size-2 uppercase font-bold" }, "Payment details", -1)),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", {
                      class: _normalizeClass([!errors.value.cardName ? 'text-theme-gray-2' : 'text-theme-error', "uppercase text-small flex items-center gap-1"])
                    }, [
                      _cache[44] || (_cache[44] = _createElementVNode("span", null, "Card holder name *", -1)),
                      (errors.value.cardName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_55, "(required)"))
                        : _createCommentVNode("", true)
                    ], 2),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((paymentDetails.value.card.name) = $event)),
                      type: "text",
                      class: "outline-none w-full h-30 font-bold text-size-6 border-none",
                      placeholder: "Name as on card"
                    }, null, 512), [
                      [_vModelText, paymentDetails.value.card.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", {
                        class: _normalizeClass([!errors.value.cardNumber ? 'text-theme-gray-2' : 'text-theme-error', "uppercase text-small flex items-center gap-1"])
                      }, [
                        _cache[45] || (_cache[45] = _createElementVNode("span", null, "Card number *", -1)),
                        (errors.value.cardNumber)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_58, "(" + _toDisplayString(errors.value.cardNumber) + ")", 1))
                          : _createCommentVNode("", true)
                      ], 2),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((paymentDetails.value.card.number) = $event)),
                        type: "number",
                        class: "outline-none w-full h-30 font-bold text-size-6 border-none",
                        placeholder: "0000 0000 0000 0000"
                      }, null, 512), [
                        [_vModelText, paymentDetails.value.card.number]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", {
                      class: _normalizeClass([!errors.value.cardCVC ? 'text-theme-gray-2' : 'text-theme-error', "uppercase text-small flex items-center gap-1"])
                    }, [
                      _cache[46] || (_cache[46] = _createElementVNode("span", null, "CVC *", -1)),
                      (errors.value.cardCVC)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_61, "(required)"))
                        : _createCommentVNode("", true)
                    ], 2),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((paymentDetails.value.card.cvc) = $event)),
                      type: "number",
                      class: "outline-none w-full h-30 font-bold text-size-6 border-none",
                      placeholder: "123"
                    }, null, 512), [
                      [_vModelText, paymentDetails.value.card.cvc]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", {
                      class: _normalizeClass([!errors.value.cardExpiration ? 'text-theme-gray-2' : 'text-theme-error', "uppercase text-small flex items-center gap-1"])
                    }, [
                      _cache[47] || (_cache[47] = _createElementVNode("span", null, "Expiration *", -1)),
                      (errors.value.cardExpiration)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_63, "(required)"))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _cache[49] || (_cache[49] = _createElementVNode("label", { class: "text-[10px] text-theme-gray-2 uppercase" }, "Month", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((expiryMonth).value = $event)),
                          onChange: updateExpiry,
                          class: "outline-none bg-theme-gray-7 rounded px-2 py-2 font-bold text-size-5 cursor-pointer appearance-none text-center"
                        }, [
                          _cache[48] || (_cache[48] = _createElementVNode("option", {
                            value: "",
                            disabled: ""
                          }, "MM", -1)),
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (m) => {
                            return _createElementVNode("option", {
                              key: m,
                              value: m.toString().padStart(2, '0')
                            }, _toDisplayString(m.toString().padStart(2, '0')), 9, _hoisted_66)
                          }), 64))
                        ], 544), [
                          [_vModelSelect, expiryMonth.value]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _cache[51] || (_cache[51] = _createElementVNode("label", { class: "text-[10px] text-theme-gray-2 uppercase" }, "Year", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((expiryYear).value = $event)),
                          onChange: updateExpiry,
                          class: "outline-none bg-theme-gray-7 rounded px-2 py-2 font-bold text-size-5 cursor-pointer appearance-none text-center"
                        }, [
                          _cache[50] || (_cache[50] = _createElementVNode("option", {
                            value: "",
                            disabled: ""
                          }, "YYYY", -1)),
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(15, (y) => {
                            return _createElementVNode("option", {
                              key: y,
                              value: (new Date().getFullYear() + y - 1).toString()
                            }, _toDisplayString(new Date().getFullYear() + y - 1), 9, _hoisted_68)
                          }), 64))
                        ], 544), [
                          [_vModelSelect, expiryYear.value]
                        ])
                      ])
                    ])
                  ])
                ]),
                (errors.value.responseError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(errors.value.responseError), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (!contactDetails.value.needConfirmation && selectedPaymentMethod.value === 'wallet')
          ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
              _cache[56] || (_cache[56] = _createElementVNode("div", { class: "bg-theme-gray-7 px-5 py-3.5 text-theme-gray-2 text-size-2 uppercase font-bold" }, "Agency Wallet Booking", -1)),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", null, [
                    _cache[53] || (_cache[53] = _createElementVNode("div", { class: "text-[10px] uppercase font-bold text-slate-400" }, "Available Wallet Balance", -1)),
                    _createElementVNode("div", _hoisted_73, _toDisplayString(agencyWallet.value.wallet_currency) + " " + _toDisplayString(agencyWallet.value.wallet_balance.toFixed(2)), 1)
                  ]),
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-wallet",
                    size: "2xl",
                    class: "text-slate-300"
                  })
                ]),
                (agencyWallet.value.has_sufficient_balance)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "fa-solid fa-circle-check",
                        size: "lg",
                        class: "text-emerald-500 shrink-0"
                      }),
                      _cache[54] || (_cache[54] = _createElementVNode("span", null, "Sufficient balance. This booking will be paid instantly using your agency credit limit.", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_75, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "fa-solid fa-circle-exclamation",
                        size: "lg",
                        class: "text-rose-500 shrink-0"
                      }),
                      _createElementVNode("span", null, [
                        _cache[55] || (_cache[55] = _createElementVNode("strong", null, "Insufficient balance!", -1)),
                        _createTextVNode(" Your available wallet credits balance (" + _toDisplayString(agencyWallet.value.wallet_currency) + " " + _toDisplayString(agencyWallet.value.wallet_balance.toFixed(2)) + ") is less than the booking amount. Please top up or pay by credit card.", 1)
                      ])
                    ])),
                (errors.value.responseError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(errors.value.responseError), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (!contactDetails.value.needConfirmation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
              _createElementVNode("div", {
                class: "bg-theme-gray-7 px-5 py-3.5 flex justify-between items-center cursor-pointer",
                onClick: togglePromo
              }, [
                _cache[57] || (_cache[57] = _createElementVNode("span", { class: "text-theme-gray-2 text-size-2 uppercase" }, "Apply Promo Code", -1)),
                _createVNode(_component_font_awesome_icon, {
                  icon: showPromo.value ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down',
                  class: "text-theme-gray-3"
                }, null, 8, ["icon"])
              ]),
              (showPromo.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((promoCode).value = $event)),
                          type: "text",
                          disabled: isApplyingPromo.value,
                          class: "outline-none w-full border border-theme-gray-7 rounded-md px-4 py-3 font-bold text-slate-700 placeholder:font-normal uppercase focus:border-theme-active transition-colors",
                          placeholder: "Enter Coupon Code",
                          onInput: _cache[17] || (_cache[17] = ($event: any) => (promoErrorMessage.value = ''))
                        }, null, 40, _hoisted_81), [
                          [_vModelText, promoCode.value]
                        ]),
                        (promoErrorMessage.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_82, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "fa-solid fa-circle-exclamation",
                                class: "mr-1"
                              }),
                              _createTextVNode(" " + _toDisplayString(promoErrorMessage.value), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("button", {
                        onClick: applyPromoCode,
                        disabled: !promoCode.value || isApplyingPromo.value,
                        class: "bg-[#0B6A1F] h-fit hover:bg-green-800 disabled:bg-slate-300 disabled:cursor-not-allowed text-white uppercase text-sm font-bold tracking-wide px-8 py-3 rounded-md transition-colors whitespace-nowrap"
                      }, [
                        (isApplyingPromo.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_84, "Applying..."))
                          : (_openBlock(), _createElementBlock("span", _hoisted_85, "Apply Offer"))
                      ], 8, _hoisted_83)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (!contactDetails.value.needConfirmation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
              _createElementVNode("div", _hoisted_87, [
                _cache[58] || (_cache[58] = _createElementVNode("span", { class: "text-xs uppercase tracking-wider" }, "Subtotal", -1)),
                _createElementVNode("span", _hoisted_88, _toDisplayString((userSearch.value?.currency || '$')) + " " + _toDisplayString((car.value?.price || 0).toFixed(2)), 1)
              ]),
              (appliedDiscount.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                    _cache[59] || (_cache[59] = _createElementVNode("span", { class: "text-xs uppercase tracking-wider" }, "Coupon Discount", -1)),
                    _createElementVNode("span", _hoisted_90, "- " + _toDisplayString((userSearch.value?.currency || '$')) + " " + _toDisplayString(appliedDiscount.value.toFixed(2)), 1)
                  ]))
                : _createCommentVNode("", true),
              _cache[61] || (_cache[61] = _createElementVNode("div", { class: "h-px bg-slate-200/60 my-1" }, null, -1)),
              _createElementVNode("div", _hoisted_91, [
                _cache[60] || (_cache[60] = _createElementVNode("span", { class: "text-base uppercase font-black text-slate-800 tracking-wide" }, "Total Amount", -1)),
                _createElementVNode("span", _hoisted_92, _toDisplayString((userSearch.value?.currency || '$')) + " " + _toDisplayString((newTotal.value || car.value?.price || 0).toFixed(2)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_93, [
          _createElementVNode("div", {
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_unref(router).push({name: 'BookingWizard', params:{step: 'choose-vehicle'}}))),
            class: "gap-4 uppercase rounded-full px-8 py-4 border-2 border-theme-gray-7 bg-theme-gray-7 hover:bg-white text-theme-gray-2 text-size-2 flex items-center justify-center cursor-pointer transition-all ease-in-out duration-500 w-full md:w-auto order-2 md:order-1"
          }, [
            _createElementVNode("span", _hoisted_94, [
              _createVNode(_component_font_awesome_icon, {
                size: "lg",
                icon: "fa-solid fa-chevron-left"
              })
            ]),
            _cache[62] || (_cache[62] = _createElementVNode("span", null, "Choose car", -1))
          ]),
          _createElementVNode("div", {
            onClick: _cache[19] || (_cache[19] = ($event: any) => (isLoading.value || (selectedPaymentMethod.value === 'wallet' && !agencyWallet.value.has_sufficient_balance) ? null : handleBookingProceed())),
            class: _normalizeClass([isLoading.value || (selectedPaymentMethod.value === 'wallet' && !agencyWallet.value.has_sufficient_balance) ? 'cursor-not-allowed opacity-60' : 'hover:bg-white hover:text-theme-active cursor-pointer', "gap-4 uppercase rounded-full px-8 py-4 border-2 border-theme-active bg-theme-active text-white text-size-2 flex items-center justify-center w-full md:w-auto md:ml-auto transition-all ease-in-out duration-500 order-1 md:order-2"])
          }, [
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_95, " Processing... "))
              : (_openBlock(), _createElementBlock("span", _hoisted_96, _toDisplayString(contactDetails.value.needConfirmation ? 'Request a Quote' : (selectedPaymentMethod.value === 'wallet' ? 'Pay by Agency Wallet' : 'Pay by Credit Card')), 1)),
            _createElementVNode("span", null, [
              (isLoading.value)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: "fa-solid fa-spinner",
                    spin: ""
                  }))
                : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 1,
                    size: "lg",
                    icon: "fa-solid fa-chevron-right"
                  }))
            ])
          ], 2)
        ])
      ])
    ]),
    _createVNode(Notification, {
      show: notif.value.show,
      type: notif.value.type,
      message: notif.value.message,
      messageDetails: notif.value.messageDetails,
      onClosed: notifClosed
    }, null, 8, ["show", "type", "message", "messageDetails"])
  ], 64))
}
}

})